var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "privacy-content" }, [
      _c("h1", [_vm._v("Privacy Policy")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("h3", [_vm._v("Last updated: April 07, 2024")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your\n      information when You use the Service and tells You about Your privacy rights and how the law protects You.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection\n      and use of information in accordance with this Privacy Policy.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("Interpretation and Definitions")]),
        _vm._v(" "),
        _c("h3", [_vm._v("Interpretation")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      The words of which the initial letter is capitalized have meanings defined under the following conditions. The\n      following definitions shall have the same meaning regardless of whether they appear in singular or in plural.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Definitions")]),
        _vm._v(" "),
        _c("p", [_vm._v("For the purposes of this Privacy Policy:")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("Account")]),
              _vm._v(
                " means a unique account created for You to access our Service or parts of our\n          Service.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("Affiliate")]),
              _vm._v(
                ' means an entity that controls, is controlled by or is under common control with\n          a party, where "control" means ownership of 50% or more of the shares, equity interest or other\n          securities entitled to vote for election of directors or other managing authority.\n        '
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("Application")]),
              _vm._v(
                " refers to LMK, the software program provided by the Company.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("Company")]),
              _vm._v(
                ' (referred to as either "the Company", "We", "Us" or\n          "Our" in this Agreement) refers to LightSpace Inc.\n        '
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("Device")]),
              _vm._v(
                " means any device that can access the Service such as a computer, a cellphone or a\n          digital tablet.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("Personal Data")]),
              _vm._v(
                " is any information that relates to an identified or identifiable individual.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("Service")]),
              _vm._v(" refers to the Application.\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("Service Provider")]),
              _vm._v(
                " means any natural or legal person who processes the data on behalf of the\n          Company. It refers to third-party companies or individuals employed by the Company to facilitate the\n          Service, to provide the Service on behalf of the Company, to perform services related to the Service or to\n          assist the Company in analyzing how the Service is used.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("Third-party Social Media Service")]),
              _vm._v(
                " refers to any website or any social network website\n          through which a User can log in or create an account to use the Service.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("Usage Data")]),
              _vm._v(
                " refers to data collected automatically, either generated by the use of the\n          Service or from the Service infrastructure itself (for example, the duration of a page visit).\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("You")]),
              _vm._v(
                " means the individual accessing or using the Service, or the company, or other legal\n          entity on behalf of which such individual is accessing or using the Service, as applicable.\n        "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("Collecting and Using Your Personal Data")]),
        _vm._v(" "),
        _c("h3", [_vm._v("Types of Data Collected")]),
        _vm._v(" "),
        _c("h4", [_vm._v("Information You Choose to Give Us")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      When you interact with our Services, we collect the information that you choose to share with us. For example,\n      most of our Services require you to set up a basic LMK account, so we may collect a few important details about\n      you, such as: name, password, a phone number, gender, and your date of birth among others.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      You’ll also provide us whatever information you send through our Services, such as messages to our users. Keep\n      in mind that the users you send messages and any other content to can always save that content or copy it\n      outside the app. So, the same common sense that applies to the internet at large applies to LMK as well: Don’t\n      send messages or share content that you wouldn’t want someone to save or share.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      When you contact customer support or communicate with us in any other way, we’ll collect whatever information\n      you volunteer as well.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      Also, LMK provides various ways to create an account such as through phone number, Facebook, or Snapchat. If\n      you sign-up with phone number, you are giving us your phone number information. If you sign-up with your\n      Facebook account, we will receive certain information about you from Facebook such as name, profile picture,\n      email, birthday, and interests. If you sign-up with your Snapchat account, we will also receive certain\n      information about you from Snapchat such as name and Bitmoji.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("Information We Get When You Use Our Services")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      When you use our Services, we collect information about which of those Services you’ve used and how you’ve used\n      them. Here’s a fuller explanation of the types of information we may collect when you use our Services:\n    "
          ),
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("p", [
              _c("b", [_vm._v("Usage Information.")]),
              _vm._v(
                " We collect information about your activity through our Services. For example, we\n          may collect information about:\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "\n          how you interact with our Services, such as which pages you view the most, how often you use our\n          Services,etc.\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          how you communicate with other users on LMK, such as their names, the time and date of your\n          communications, the number of messages you exchange with your friends, which friends you exchange messages\n          with the most, and your interactions with messages (such as when you open a message or capture a\n          screenshot).\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("b", [_vm._v("Content Information. ")]),
              _vm._v(
                "We collect content you create on our Services and information about the content\n          you create or provide, such as if the recipient has viewed the content and the metadata that is provided\n          with the content.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("b", [_vm._v("Device Information. ")]),
              _vm._v(
                " We collect information from and about the devices you use. \n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("b", [_vm._v("Device Phonebook. ")]),
              _vm._v(
                "We —with your permission—collect information from your device’s phonebook.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("b", [_vm._v("Camera and Photos. ")]),
              _vm._v(
                "Some of our Services require us to collect images and other information from your\n          device’s camera and photos. \n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("b", [_vm._v("Location Information. ")]),
              _vm._v(
                "When you use our Services we may collect information about your location with\n          your permission. With your permission, we may also collect information about your precise location using\n          methods that include GPS, wireless networks, cell towers, Wi-Fi access points, and other sensors, such as\n          gyroscopes, accelerometers, and compasses.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("b", [
                _vm._v(
                  "Information Collected by Cookies and Other Technologies. "
                ),
              ]),
              _vm._v(
                "Like most online services and mobile\n          applications, we may use cookies and other technologies, such as web beacons, web storage, and unique\n          advertising identifiers, to collect information about your activity, browser, and device. Most web browsers\n          are set to accept cookies by default. If you prefer, you can usually remove or reject browser cookies\n          through the settings on your browser or device. Keep in mind, though, that removing or rejecting cookies\n          could affect the availability and functionality of our services. \n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("b", [_vm._v("Log Information. ")]),
              _vm._v(
                "We also collect log information when you use our website. That information\n          includes, among other things: \n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [_vm._v("details about how you’ve used our services.")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "device information, such as your web browser type and language."
              ),
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("access times.")]),
            _vm._v(" "),
            _c("li", [_vm._v("pages viewed.")]),
            _vm._v(" "),
            _c("li", [_vm._v("IP address.")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          identifiers associated with cookies or other technologies that may uniquely identify your device or\n          browser.\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "pages you visited before or after navigating to our website."
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("b", [_vm._v("In app purchase. ")]),
              _vm._v(
                "When you subscribe to a paid service or make any other type of purchase or make a\n          purchase directly from us (rather than through a platform such as iOS or Android), you provide us or our\n          payment information. If you request a refund from Apple, we will provide them with your transaction data from our platform as per their requirements for processing.\n        "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      We use this information to provide features of Our Service, to improve and customize Our Service. The\n      information may be uploaded to the Company's servers and/or a Service Provider's server or it may be simply\n      stored on Your device.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      You can enable or disable access to this information at any time, through Your Device settings.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("Information We Collect from Third Parties")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      We may collect information about you from other users and third parties. For example,if another user uploads\n      their contact list, we may combine information from that user’s contact list with other information we have\n      collected about you.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      The Company allows You to create an account and log in to use the Service through the following Third-party\n      Social Media Services:\n    "
          ),
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("strong", [_vm._v("Facebook: ")]),
            _vm._v(
              " We ask for some Facebook permissions allowing it to perform actions with the Your\n        Facebook account and to retrieve information, including Personal Data, from it. This service allows this\n        Application to connect with the Your account on the Facebook social network, provided by Facebook Inc. The\n        permissions asked are the following: Provides access to the birthday, email , gender and public profile.\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      If You decide to register through or otherwise grant us access to a Third-Party Social Media Service, We may\n      collect Personal data that is already associated with Your Third-Party Social Media Service's account, such as\n      Your name, Your email address, Your activities or Your contact list associated with that account.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      You may also have the option of sharing additional information with the Company through Your Third-Party Social\n      Media Service's account. If You choose to provide such information and Personal Data, during registration or\n      otherwise, You are giving the Company permission to use, share, and store it in a manner consistent with this\n      Privacy Policy.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Use of Your Personal Data")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      The information we collect is used to provide you with an amazing set of products and services that we\n      relentlessly\n      improve. Here are some ways we do that:\n    "
          ),
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("To manage Your Account:")]),
              _vm._v(
                " to manage Your registration as a user of the Service. The Personal\n          Data You provide can give You access to different functionalities of the Service that are available to You\n          as a registered user.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("To provide and maintain our Service")]),
              _vm._v(
                ", including to monitor the usage of our Service and to\n          provide various services based on different conditions.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("To contact You:")]),
              _vm._v(
                " To contact You by email, telephone calls, SMS, or other equivalent forms\n          of electronic communication, such as a mobile application's push notifications regarding updates or\n          informative communications related to the functionalities, products or contracted services, including the\n          security updates, when necessary or reasonable for their implementation.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("To provide You")]),
              _vm._v(
                " with personalized contents, such as posts and friends.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("To manage Your requests:")]),
              _vm._v(" To attend and manage Your requests to Us.\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [
              _vm._v(
                "To enhance the safety and security of Your information, "
              ),
            ]),
            _vm._v(
              " including to verify your identity\n        and prevent fraud or other unauthorized or illegal activity\n      "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("For business transfers:")]),
              _vm._v(
                " We may use Your information to evaluate or conduct a merger,\n          divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our\n          assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which\n          Personal Data held by Us about our Service users is among the assets transferred.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("For other purposes")]),
              _vm._v(
                ": We may use Your information for other purposes, such as data analysis,\n          identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and\n          improve our Service, products, services, marketing and your experience.\n        "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "We may share Your personal information in the following situations:"
          ),
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [_c("p", [_c("strong", [_vm._v("With other users:")])])]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "information about you, such as your name, interests, bio, gender, among others."
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "any additional information you have directed us to share."
              ),
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("content you post or send.")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [
                _vm._v("With our business partners, and the general public:"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v("public information like your name and album pictures."),
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("content that you have made public")]),
          ]),
          _vm._v(" "),
          _c("li", [_c("p", [_c("strong", [_vm._v("With third parties:")])])]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "\n          With service providers. We may share information about you with service providers who perform services on\n          our behalf. \n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          With business partners. We may share information about you with business partners that provide services\n          and functionality. \n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          With third parties for legal reasons. We may share information about you if we reasonably believe that\n          disclosing the information is needed to:\n        "
              ),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "comply with any valid legal process, governmental request, or applicable law, rule, or regulation."
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "investigate, remedy, or enforce potential Terms of Service violations."
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "protect the rights, property, and safety of us, our users, or others."
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("detect and resolve any fraud or security concerns."),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          With third parties as part of a merger or acquisition. If LMK gets involved in a merger, asset sale,\n          financing, liquidation or bankruptcy, or acquisition of all or some portion of our business to another\n          company, we may share your information with that company before and after the transaction closes.\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          We may also share with third parties—such as advertisers—aggregated, non-personally identifiable, or\n          de-identified information.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("With Your consent")]),
              _vm._v(
                ": We may disclose Your personal information for any other purpose with\n          Your consent.\n        "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Retention of Your Personal Data")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this\n      Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal\n      obligations (for example, if we are required to retain your data to comply with applicable laws), resolve\n      disputes, and enforce our legal agreements and policies.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for\n      a\n      shorter period of time, except when this data is used to strengthen the security or to improve the\n      functionality\n      of Our Service, or We are legally obligated to retain this data for longer time periods.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Transfer of Your Personal Data")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      Your information, including Personal Data, is processed at the Company's operating offices and in any other\n      places where the parties involved in the processing are located. It means that this information may be\n      transferred to — and maintained on — computers located outside of Your state, province, country or other\n      governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement\n      to that transfer.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in\n      accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization\n      or\n      a country unless there are adequate controls in place including the security of Your data and other personal\n      information.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Delete Your Personal Data")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      You have the right to delete or request that We assist in deleting the Personal Data that We have collected\n      about You.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      Our Service may give You the ability to delete certain information about You from within the Service.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one,\n      and visiting the account settings section that allows you to manage Your personal information. You may also\n      contact Us to request access to, correct, or delete any personal information that You have provided to Us.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      Please note, however, that We may need to retain certain information when we have a legal obligation or\n      lawful\n      basis to do so.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Third-party Content and Integrations")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      Our services may also contain third-party links and search results, include third-party integrations, or offer\n      a co-branded or third-party-branded service. Through these links, third-party integrations, and co-branded or\n      third-party-branded services, you may be providing information (including personal information) directly to the\n      third party, us, or both. You acknowledge and agree that we are not responsible for how those third parties\n      collect or use your information. As always, we encourage you to review the privacy policies of every third-party\n      service that you visit or use, including those third parties you interact with through our services.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("strong", [_vm._v("YouTube API")]),
            _vm._v(": to display videos in the app. Please confirm the "),
            _c(
              "a",
              { attrs: { href: "https://policies.google.com/privacy" } },
              [_vm._v("Google Privacy Policy ")]
            ),
            _vm._v(".\n      "),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Firebase API")]),
            _vm._v(": to analysis user behaviour. Please confirm the "),
            _c(
              "a",
              {
                attrs: { href: "https://firebase.google.com/support/privacy" },
              },
              [_vm._v(" Firebase Privacy Policy")]
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Facebook API")]),
            _vm._v(": as a choice for user to login. Please confirm the "),
            _c(
              "a",
              { attrs: { href: "https://www.facebook.com/privacy/policy" } },
              [_vm._v(" Facebook Privacy Policy")]
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Google API")]),
            _vm._v(
              ": as a choice for user to login. We use and transfer to any other app of information received from Google APIs will adhere to  \n        "
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes",
                },
              },
              [_vm._v(" Google API Services User Data Policy\n        ")]
            ),
            _vm._v(
              "\n        , including the Limited Use requirements. And we also commit to \n        "
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://play.google.com/about/developer-distribution-agreement.html",
                },
              },
              [
                _vm._v(
                  " Google Play Developer Distribution Agreement\n        "
                ),
              ]
            ),
            _vm._v(".\n      "),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("AWS")]),
            _vm._v(": to data storage. Please read the "),
            _c("a", { attrs: { href: "https://aws.amazon.com/privacy/" } }, [
              _vm._v(" AWS Privacy\n          Policy"),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Disclosure of Your Personal Data")]),
        _vm._v(" "),
        _c("h4", [_vm._v("Business Transactions")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We\n      will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy\n      Policy.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("Law enforcement")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so\n      by\n      law or in response to valid requests by public authorities (e.g. a court or a government agency).\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("Other legal requirements")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:"
          ),
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [_vm._v("Comply with a legal obligation")]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Protect and defend the rights or property of the Company"),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Prevent or investigate possible wrongdoing in connection with the Service"
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Protect the personal safety of Users of the Service or the public"
            ),
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("Protect against legal liability")]),
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Security of Your Personal Data")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      The security of Your Personal Data is important to Us, but remember that no method of transmission over the\n      Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means\n      to protect Your Personal Data, We cannot guarantee its absolute security.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("Links to Other Websites")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      Our Service may contain links to other websites that are not operated by Us. If You click on a third party\n      link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of\n      every site You visit.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      We have no control over and assume no responsibility for the content, privacy policies or practices of any\n      third party sites or services.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h2", [
          _vm._v(
            " The rights of Users based on the General Data Protection Regulation (GDPR) "
          ),
        ]),
        _vm._v(" "),
        _c("h3", [
          _vm._v(
            "Users may exercise certain rights regarding their Data processed by the Owner."
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "In particular, Users have the right to do the following, to the extent permitted by law: "
          ),
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _vm._v(
              "\n        Withdraw their consent at any time. Users have the right to withdraw consent where they have previously\n        given their consent to the processing of their Personal Data.\n      "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n        Object to processing of their Data. Users have the right to object to the processing of their Data if the\n        processing is carried out on a legal basis other than consent.\n      "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n        Access their Data. Users have the right to learn if Data is being processed by the Owner, obtain disclosure\n        regarding certain aspects of the processing and obtain a copy of the Data undergoing processing.\n      "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n        Verify and seek rectification. Users have the right to verify the accuracy of their Data and ask for it to\n        be updated or corrected.\n      "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n        Restrict the processing of their Data. Users have the right to restrict the processing of their Data. In\n        this case, the Owner will not process their Data for any purpose other than storing it.\n      "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n        Have their Personal Data deleted or otherwise removed. Users have the right to obtain the erasure of their\n        Data from the Owner.\n      "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n        Receive their Data and have it transferred to another controller. Users have the right to receive their Data\n        in a structured, commonly used and machine readable format and, if technically feasible, to have it\n        transmitted to another controller without any hindrance.\n      "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n        Lodge a complaint. Users have the right to bring a claim before their competent data protection authority.\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      Users are also entitled to learn about the legal basis for Data transfers abroad including to any international\n      organization governed by public international law or set up by two or more countries, such as the UN, and about\n      the security measures taken by the Owner to safeguard their Data.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Details about the right to object to processing")]),
        _vm._v(" "),
        _c("p", [
          _c("strong", [
            _vm._v(
              "Where Personal Data is processed for a public interest, in the exercise of an official authority vested\n        in the Owner or for the purposes of the legitimate interests pursued by the Owner, Users may object to such\n        processing by providing a ground related to their particular situation to justify the objection."
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("strong", [
            _vm._v(
              "Users must know that, however, should their Personal Data be processed for direct marketing purposes,\n        they can object to that processing at any time, free of charge and without providing any justification. Where\n        the User objects to processing for direct marketing purposes, the Personal Data will no longer be processed\n        for such purposes. To learn whether the Owner is processing Personal Data for direct marketing purposes, Users\n        may refer to the relevant sections of this document."
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("How to exercise these rights")]),
        _vm._v(" "),
        _c("p", [
          _c("strong", [
            _vm._v(
              "Any requests to exercise User rights can be directed to the Owner through the contact details provided\n        in this document. Such requests are free of charge and will be answered by the Owner as early as possible and\n        always within one month, providing Users with the information required by law. Any rectification or erasure of\n        Personal Data or restriction of processing will be communicated by the Owner to each recipient, if any, to\n        whom the Personal Data has been disclosed unless this proves impossible or involves disproportionate effort.\n        At the Users’ request, the Owner will inform them about those recipients."
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("Changes to this Privacy Policy")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new\n      Privacy Policy on this page.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            '\n      We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming\n      effective\n      and update the "Last updated" date at the top of this Privacy Policy.\n    '
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy\n      are\n      effective when they are posted on this page.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("Contact Us")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "If you have any questions about this Privacy Policy, You can contact us:"
          ),
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _vm._v("\n        By visiting our website "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://lmk.zendesk.com/hc/en-us/requests/new",
                  rel: "external nofollow noopener",
                  target: "_blank",
                },
              },
              [
                _vm._v(
                  "\n          https://lmk.zendesk.com/hc/en-us/requests/new"
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("\n        By email: "),
            _c(
              "a",
              {
                attrs: {
                  href: "help@lmk.chat",
                  rel: "external nofollow noopener",
                  target: "_blank",
                },
              },
              [_vm._v(" help@lmk.chat")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("\n      LightSpace, Inc. "),
          _c("br"),
          _vm._v("\n      Suite 5-204, 23 Lime Tree Bay Avenue "),
          _c("br"),
          _vm._v("\n      rand Cayman, KY 1 1104 KY\n    "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/common/Privacy.vue